import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getSmsTemplateFormInputs } from "../model/sms-template.modal";
import { menuUrl } from "../sms-template-list/model/sms-template-list.constants";
import { editSmsTemplateApi } from "./sms-template-edit.component.service";
import SmsTemplateEditTemplateComponent from "./sms-template-edit-template.component";
import { APP } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  SMS_TEMPLATE_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const SmsTemplateEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const { PRIMARY_KEY } = APP;
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };
  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSmsTemplateSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct menu item payload
    let smsTemplatePayload = {};
    for (let i = 0; i < values.length; i++) {
      smsTemplatePayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const smsTemplateResponse = await editSmsTemplateApi(
      location?.state?.row[PRIMARY_KEY],
      smsTemplatePayload
    );

    // INFO : check api response and show relevant alert message
    if (smsTemplateResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: smsTemplateResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getSmsTemplateFormInputs({
      name: location?.state?.row?.name || "",
      content: location?.state?.row?.content || "",
      status: location?.state?.row?.status || "",
    }),
  };

  const templateEvents = {
    handleSmsTemplateSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <SmsTemplateEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default SmsTemplateEditComponent;
